<template>
    <div>
        <div id="func-content">
            <div v-for="b in branditem" :key="b.index">
                <order-control-setting-item
                    :brandCode="b.brandCode"
                    :brandName="b.brandName"
                    :weekdayLastOrderTime.sync="b.weekdayLastOrderTime"
                    :holidayLastOrderTime.sync="b.holidayLastOrderTime"
                    :periodIntervalTime.sync="b.periodIntervalTime"
                    :makeMealTime.sync="b.makeMealTime"
                    :periodAmount.sync="b.periodAmount"
                    :overAmount.sync="b.overAmount"
                    :setActivity.sync="b.setActivity"
                    @edit="handleEdit(b.brandCode)"
                    @confirm="handleConfirm(b.brandCode)"
                    @cancel="handleCancel(b.brandCode)"
                    @chkCancel="chkCancel()"
                    @chkSave="chkSave(b.brandCode)"
                />
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import OrderControlSettingItem from './OrderControlSettingItem.vue';
miniToastr.init()

export default {
  components: {
    OrderControlSettingItem
  },
  data () {
    return {
      brands:[
        {sort:1,code:'MWD',name:'麥味登'},
        {sort:2,code:'CM',name:'炸鷄大師'},
        {sort:3,code:'REAL',name:'REAL'},
      ],
      branditem:[],
    }
  },
  created () {
      this.brands.forEach(element => {
        this.query(element)
      });
  },
  methods: {
    query (brand) {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getOrderSettingMeal/v1', {
        mode: 'workMode',
        brandCode:brand.code
      })
    .then((response) => {
        this.$store.commit('TOKEN', response.data.jwt)
        this.$parent.Loading = false
        if (response.data.result === '0000') {
        this.item = response.data.data
        var b = {...this.item,brandCode:brand.code,brandName:brand.name,setActivity:false,sort:brand.sort}
        if(!this.branditem.some(x=>x.brandCode == b.brandCode)){
            this.branditem.push(b)
        }
        //排序
         var tobj = Object.entries(this.branditem).sort(([, a], [, b]) => a.sort - b.sort);
         var temp = []
         tobj.forEach(x=>{
            temp.push(x[1])
        })
        this.branditem = temp
        } else if (response.data.result === '0006') {
        this.$parent.logOut(true, true)
        } else {
        miniToastr.error(response.data.message, '資料讀取異常')
        console.log(response.data.message)
        }
    })
    .catch((error) => {
        this.$parent.Loading = false
        miniToastr.error(error, '資料讀取異常')
        console.log(error)
    })
    },
    chkCancel () {
    },
    chkSave (code) {
        this.branditem.find(x=>x.brandCode === code).setActivity = false
    },
    handleEdit(code){
        this.branditem.find(x=>x.brandCode === code).setActivity = true
    },
    handleConfirm(code){
    },
    handleCancel(code){
        this.branditem.find(x=>x.brandCode === code).setActivity = false
    },
},
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/shopping/ordersetting/OrderControlSetting.vue